<template>
  <div class="about">
    <div class="header container">
      <view-nav></view-nav>
    </div>
    <div class="head-box container">
      <img src="../assets/images/about/head-box-background.png" alt="">
      <div class="shuiyin"></div>
      <div class="intro-box">
        <h2>让文化插上翅膀<br>用科技赋能文博</h2>
        <div class="intro">
          <p>“中华文物云”是在国家文物局领导下，由中国文物报社、腾讯云、微景天下三方共同发起的文化遗产行业云平台，作为“中华文物全媒体传播计划”的两大基础资源平台之一，面向全国文物博物馆单位和文化文博机构，汇集文博数字文化、文创产品、云展览和文博教育等几大类文化遗产数据资源线上云平台。“中华文物云”面向全国文物博物馆单位，提供十大精品陈列展申报、核心价值观展申报、展览数据管理、搭建数字展览产品、打造智慧博物馆等一站式数字可视化解决方案。</p>
          <a href="javascript:;" @click="ruzhu">申请入驻</a>
        </div>
      </div>
    </div>
    <div class="about-intro-area container">
      <h2>我们的优势</h2>
      <h3>OUR STRENGTHS</h3>
      <div class="about-intro-box1">
        <ul class="box1-title">
          <li :class="{'selected': strengths === 1}" @click="strengths = 1">服务优势</li>
          <li :class="{'selected': strengths === 2}" @click="strengths = 2">内容优势</li>
          <li :class="{'selected': strengths === 3}" @click="strengths = 3">平台优势</li>
        </ul>
        <ul class="box1-content" v-show="strengths === 1">
          <li>
            <h4>专业团队</h4>
            <p>核心人员均毕业于国内外知名大学，具有一流的专业水平、严谨的工作作风和丰富的业务经验</p>
          </li>
          <li>
            <h4>专控指标</h4>
            <p>多项加严服务指标跟踪服务进程，及时发现异常状态并确保客户得到统一高品质服务</p>
          </li>
          <li>
            <h4>专属服务</h4>
            <p>专属定制，根据需求建立专属博物馆，1V1专业博物馆方向产品策划定制博物馆数字展示方案</p>
          </li>
        </ul>
        <ul class="box1-content" v-show="strengths === 2">
          <li>
            <h4>直播逛展</h4>
            <p>直播页面可嵌入数字展览产品，用户以全景视角直观了解与直播相关的呈现内容</p>
          </li>
          <li>
            <h4>VR全景漫游</h4>
            <p>依托数字网络和融媒技术，可高度还原文物物体质感和展览环境的现场效果</p>
          </li>
        </ul>
        <ul class="box1-content" v-show="strengths === 3">
          <li>
            <h4>技术实力</h4>
            <p>自主研发的三维全景拼接重建算法和独立自控的渲染引擎，已获20余项专利和软著授权</p>
          </li>
          <li>
            <h4>管理后台</h4>
            <p>官方活动申报、数据实时查看、专家在线评审、数据安全保障，为客户提供最贴心的后台管家服务</p>
          </li>
          <li>
            <h4>多终端传播</h4>
            <p>支持PC端、移动端，可开发VR端、大屏端，适用于多类平台的传播与推广，达到品牌效应</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="about-intro-area container gray">
      <h2>服务案例</h2>
      <h3>SERVICE CASES</h3>
      <div class="about-intro-box2">
        <swiper ref="serviceSwiper" class="service-swiper" :options="serviceSwiperOption">
          <swiper-slide class="slide">
            <div class="img-box">
              <img src="../assets/images/about/swipe-img-1.jpg" alt="">
              <img src="../assets/images/about/swipe-img-2.png" alt="">
              <img src="../assets/images/about/swipe-img-3.jpg" alt="">
            </div>
          </swiper-slide>
          <swiper-slide class="slide">
            <div class="img-box">
              <img src="../assets/images/about/swipe-img-4.png" alt="">
              <img src="../assets/images/about/swipe-img-5.jpg" alt="">
              <img src="../assets/images/about/swipe-img-6.png" alt="">
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>
    <div class="about-intro-area container">
      <h2>流程与支持</h2>
      <h3>PROCESS AND SUPPORT</h3>
      <div class="about-intro-box3">
        <ul class="ul-line">
          <li>
            <div class="icon icon0"></div>
            <div class="p">
              <p>需求沟通</p>
            </div>
          </li>
          <li>
            <div class="icon icon1"></div>
            <div class="p">
              <p>资源筛选</p>
            </div>
          </li>
          <li>
            <div class="icon icon2"></div>
            <div class="p">
              <p>开通账号</p>
            </div>
          </li>
          <li>
            <div class="icon icon3"></div>
            <div class="p">
              <p>产品培训</p>
            </div>
          </li>
          <li>
            <div class="icon icon4"></div>
            <div class="p">
              <p>正式线上</p>
            </div>
          </li>
        </ul>
        <ul class="ul-box">
          <li>
            <div class="icon icon0"></div>
            <h4>技术支持</h4>
            <p>支持H5、SDK接入<br>支持企业私有化部署</p>
          </li>
          <li>
            <div class="icon icon1"></div>
            <h4>技术培训</h4>
            <p>专业培训人员支持<br>支持在线培训、现场培训</p>
          </li>
          <li>
            <div class="icon icon2"></div>
            <h4>金牌客服</h4>
            <p>7*10h在线（9:00-19:00）<br>解答各种产品使用问题</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="about-intro-area click-box" @click="ruzhu">
      <h2 class="have-arrow">申请入驻</h2>
      <h3>APPLY FOR RESIDENCE</h3>
    </div>

    <!--入住弹框提示-->
    <div class="ruzhu-alert-box" v-show="showQRCode" @click.stop="showQRCode = false">
      <div class="alert-box" @click.stop="">
        <img class="qr-code" src="../assets/temp/ruzhu-qrcode-sj.png" alt="">
        <p>扫码联系工作人员申请入驻</p>
        <div class="close" @click.stop="showQRCode = false"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'About',
  components: {
  },
  data () {
    return {
      strengths: 1,
      serviceSwiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      showQRCode: false
    }
  },
  created () {

  },
  mounted () {
    this.util.addMtah5ClickStat('about')
  },
  methods: {
    toUrl (url) {
      window.open(url, '_blank')
    },
    ruzhu () {
      this.showQRCode = true
    }
  }
}
</script>
<style lang="scss">
  .about {
    width: 100%;
    min-width: 1200px;
    .head-box{
      width: 100%;
      height: 586px;
      overflow: hidden;
      position: relative;
      img{
        width: 100%;
        height: 586px;
      }
      .shuiyin{
        width: 564px;
        height: 564px;
        background: url("../assets/images/about/head-box-shuiyin.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 0;
        margin-left: -500px;
      }
      .intro-box{
        width: 1000px;
        position: absolute;
        left: 50%;
        top: 0;
        margin-left: -500px;
        h2{
          padding: 138px 30px 35px;
          font-size: 40px;
          color: #ffffff;
          line-height: 60px;
          letter-spacing: 4px;
        }
        .intro{
          width: 100%;
          height: 233px;
          background: rgba(255,255,255,0.1);
          position: relative;
          p{
            margin-left: 30px;
            padding-top: 16px;
            width: 540px;
            font-size: 16px;
            line-height: 30px;
            color: #ffffff;
            text-align: justify;
          }
          a{
            display: block;
            width: 230px;
            height: 60px;
            background: rgba(255,39,0,0.6);
            border-radius: 2px;
            font-size: 35px;
            line-height: 60px;
            text-indent: 35px;
            color: #ffffff;
            position: absolute;
            right: 60px;
            top: 50%;
            margin-top: -30px;
            &::after{
              content: ' ';
              display: block;
              width: 0;
              height: 0;
              border-top: 8px solid transparent;
              border-left: 8px solid #ffffff;
              border-bottom: 8px solid transparent;
              position: absolute;
              top: 22px;
              right: 29px;
            }
          }
        }
      }
    }
    .about-intro-area{
      width: 100%;
      padding-top: 40px;
      padding-bottom: 60px;
      background: #ffffff;
      &.click-box{
        width: 200px;
        margin: 0 auto;
        cursor: pointer;
      }
      &.gray{
        background:rgba(232,231,238,1);
      }
      h2{
        font-size: 35px;
        line-height: 35px;
        letter-spacing: 2px;
        color: rgba(27,35,46,1);
        margin-bottom: 22px;
        text-align: center;
        position: relative;
        &.have-arrow::before{
          content: ' ';
          display: block;
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          border-left: 8px solid rgba(255,39,0,1);
          border-bottom: 8px solid transparent;
          position: absolute;
          top: 9px;
          left: 50%;
          margin-left: 90px;
        }
      }
      h3{
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 1px;
        color: rgba(255,39,0,1);
        text-align: center;
      }
    }
    .about-intro-box1{
      width: 1000px;
      margin: 0 auto;
      padding-top: 70px;
      .box1-title{
        width: 100%;
        border-bottom: 1px solid #f8f8f8;
        display: flex;
        justify-content: space-between;
        li{
          font-size: 24px;
          line-height: 84px;
          color: rgba(27,35,46,1);
          border-bottom: 2px solid rgba(0,0,0,0);
          cursor: pointer;
          &.selected{
            border-bottom: 2px solid #ff2700;
          }
          &:nth-of-type(1){
            flex: 3;
            text-align: left;
          }
          &:nth-of-type(2){
            flex: 4;
            text-align: center;
          }
          &:nth-of-type(3){
            flex: 3;
            text-align: right;
          }
        }
      }
      .box1-content{
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 100px;
        li{
          width: 300px;
          height: 249px;
          border: 1px solid rgba(0,0,0,0.15);
          box-shadow: 0 10px 20px 0 rgba(0,0,0,0.04);
          border-radius: 10px;
          margin-right: 50px;
          &:nth-last-of-type(1){
            margin-right: 0;
          }
          h4{
            font-size: 24px;
            line-height: 24px;
            padding-top: 48px;
            padding-bottom: 38px;
            text-align: center;
            color: rgba(27,35,46,1);
            font-weight: bold;
          }
          p{
            margin: 0 auto;
            width: 230px;
            font-size: 16px;
            line-height: 30px;
            color: rgba(27,35,46,1);
            text-align: justify;
          }
        }
      }
    }
    .about-intro-box2{
      width: 1100px;
      margin: 60px auto 0;
      position: relative;
      .service-swiper{
        width: 100%;
        height: 524px;
        .slide{
          width: 100%;
        }
        .img-box{
          padding: 0 50px;
          width: 1000px;
          height: 484px;
          display: flex;
          justify-content: space-between;
          img{
            width: 300px;
            height: 484px;
            border-radius: 11px;
            box-shadow:0 18px 18px 0 rgba(61,110,146,0.2);
          }
        }
      }
      .pagination-box{
        display: inline-block;
        margin: 0 auto;
        position: relative;
        height: 32px;
      }
      .swiper-button-prev{
        width: 32px;
        height: 32px;
        background: url("../assets/images/about/arrow-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        bottom: -26px;
        top: auto;
        transform: translateX(-100px);
      }
      .swiper-button-next{
        width: 32px;
        height: 32px;
        background: url("../assets/images/about/arrow-right.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        bottom: -26px;
        top: auto;
        transform: translateX(68px);
      }
      .swiper-pagination{
        position: absolute;
        left: 50%;
        bottom: -20px;
        top: auto;
        transform: translateX(-50%);
        .swiper-pagination-bullet{
          width:6px;
          height:6px;
          background:rgba(134,142,156,0.6);
          border-radius: 50%;
          margin-right: 8px;
          &:nth-last-of-type(1){
            margin-right: 0;
          }
        }
        .swiper-pagination-bullet-active{
          background:rgba(134,142,156,1);
        }
      }
    }
    .about-intro-box3{
      width: 1000px;
      margin: 0 auto;
      padding-top: 100px;
      .ul-line{
        width: 100%;
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-bottom: 160px;
        li{
          width: 100px;
          margin-right: 124px;
          position: relative;
          &:nth-last-of-type(1){
            margin-right: 0;
          }
          .icon{
            width: 100px;
            height: 100px;
            margin-bottom: 110px;
          }
          .icon0{
            background: url("../assets/images/about/icon0.png") no-repeat 0 0;
            background-size: 100% 100%;
          }
          .icon1{
            background: url("../assets/images/about/icon1.png") no-repeat 0 0;
            background-size: 100% 100%;
          }
          .icon2{
            background: url("../assets/images/about/icon2.png") no-repeat 0 0;
            background-size: 100% 100%;
          }
          .icon3{
            background: url("../assets/images/about/icon3.png") no-repeat 0 0;
            background-size: 100% 100%;
          }
          .icon4{
            background: url("../assets/images/about/icon4.png") no-repeat 0 0;
            background-size: 100% 100%;
          }
          .p{
            width: 100%;
            height: 26px;
            position: relative;
            p{
              font-size: 26px;
              line-height: 26px;
              display: inline-block;
              position: absolute;
              left: 50%;
              top: 0;
              transform: translateX(-50%);
              word-break: keep-all;
            }
          }
          &::before{
            content: ' ';
            width: 26px;
            height: 6px;
            background: #ffffff;
            position: absolute;
            left: 50%;
            top: 160px;
            margin-left: -13px;
            z-index: 1;
          }
          &::after{
            content: ' ';
            width: 6px;
            height: 6px;
            background: #FF2700;
            position: absolute;
            left: 50%;
            top: 160px;
            margin-left: -3px;
            border-radius: 50%;
            z-index: 2;
          }
        }
        &::before{
          content: ' ';
          width: 900px;
          height: 1px;
          background: #FF2700;
          position: absolute;
          left: 50px;
          top: 163px;
        }
        &::after{
          content: ' ';
          width: 100px;
          height: 4px;
          background: #FF2700;
          position: absolute;
          left: 450px;
          bottom: 60px;
        }
      }
      .ul-box{
        width: 1000px;
        height: 249px;
        border-radius:10px;
        border:1px solid rgba(0,0,0,0.15);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        li{
          flex: 1;
          position: relative;
          height: 249px;
          text-align: center;
          &::after{
            content: ' ';
            width: 1px;
            height: 140px;
            background: #eaeaea;
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -70px;
          }
          &:nth-of-type(2){
            flex: 1.2;
          }
          &:nth-last-of-type(1)::after{
            display: none;
          }
          .icon{
            width: 60px;
            height: 60px;
            margin-top: 37px;
            display: inline-block;
            &.icon0{
              background: url("../assets/images/about/icon-0.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
            &.icon1{
              background: url("../assets/images/about/icon-1.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
            &.icon2{
              background: url("../assets/images/about/icon-2.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
          }
          h4{
            font-size: 24px;
            line-height: 24px;
            color: rgba(27, 35, 46, 1);
            margin-top: 18px;
            margin-bottom: 13px;
          }
          p{
            font-size: 16px;
            line-height: 30px;
            color: rgba(27, 35, 46, 1);
          }
        }
      }
    }
    .ruzhu-alert-box{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0,0,0,0.7);
      z-index: 999;
      .alert-box{
        width: 400px;
        height: 300px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -200px;
        margin-top: -150px;
        background: #ffffff;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .qr-code{
          margin-top: 20px;
          width: 144px;
          height: 144px;
        }
        p{
          font-size: 16px;
          margin-top: 10px;
        }
        .close{
          width: 30px;
          height: 30px;
          background: url("../assets/images/icon-marker-close.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          right: 10px;
          top: 10px;
          cursor: pointer;
        }
      }
    }
  }
</style>
